import { XML_GetScale } from "./XML_GetScale";
import { XML_ConvertDPI } from "./XML_ConvertDPI";

export function XML_Scale(v, drawElement, layer) {
  v = XML_ConvertDPI(v);
  var scale = XML_GetScale(drawElement, layer); // drawElement["scale"];
  if (scale != null) v = v * scale; //RoundTo3

  return v;
}
